import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, Shield, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo, Avatar } from "@/components/Brand";
import { BottomNav, navItems } from "@/components/BottomNav";
import { HeaderShortcuts } from "@/components/Shortcuts";

const linkCls = ({ isActive }) =>
  `flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${isActive ? "bg-white/10 text-white" : "text-muted-foreground hover:text-white"}`;

export function AppShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = navItems(user);
  const doLogout = async () => {
    await logout();
    navigate("/entrar");
  };
  return (
    <div className="min-h-screen pb-20 md:pb-0">
      <header className="glass sticky top-0 z-40 border-b border-white/5">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-8">
          <Logo />
          <nav className="hidden md:flex items-center gap-1">
            {items.map((i) => (
              <NavLink key={i.to} to={i.to} end className={linkCls} data-testid={i.testid}>
                <i.icon size={16} /> {i.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2 sm:gap-3">
            <HeaderShortcuts />
            <Link to="/gravar" className="hidden md:inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--gold))] px-4 h-9 text-sm font-extrabold text-[#0B0F17] transition-transform active:scale-95" data-testid="header-record-button">
              <Plus size={16} /> Gravar
            </Link>
            <span className="hidden xl:inline-flex items-center gap-1.5 rounded-full border border-violet-500/30 bg-violet-500/10 px-3 py-1 text-xs font-semibold text-violet-300" data-testid="ia-bodyguard-status-alert">
              <Shield size={13} /> Guarda-Costas IA ativo
            </span>
            <Link to={`/perfil/${user.id}`} className="flex items-center gap-2 rounded-full transition-opacity hover:opacity-80" data-testid="header-user">
              <Avatar name={user.name} src={user.avatar_url || user.logo_url} size={32} />
              <span className="hidden lg:block text-sm font-semibold max-w-[140px] truncate">{user.name}</span>
            </Link>
            <button onClick={doLogout} className="hidden md:grid h-9 w-9 place-items-center rounded-full text-muted-foreground hover:bg-white/10 hover:text-white transition-colors" data-testid="logout-button" aria-label="Sair">
              <LogOut size={17} />
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-3 md:px-8">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
